import { useLocation } from '@k2/core/location'
import { isSSR } from '@k2/core/util'
import { OAuthType, useOAuth } from 'vue-oidc'
import type { NavigationGuardWithThis, RouteLocationNormalized } from 'vue-router'

export const loginGuard: NavigationGuardWithThis<undefined> = async (to: RouteLocationNormalized) => {
  if (isSSR) return true

  const { returnUrl, invite } = to.query
  const { login } = useOAuth()
  await login({
    redirectUri: `${process.env.APP_DOMAIN || useLocation()?.origin}/callback`,
    responseType: OAuthType.AUTHORIZATION_CODE,
    accessType: 'offline',
    prompt: 'consent',
    state: JSON.stringify({ returnUrl }),
    ...(typeof invite === 'string' && { extras: { invite } })
  })

  return true
}
